import React, { useState } from "react";
import MyAccountLayout from "./MyAccountLayout";
import ChangePassword from "../User/ChangePassword";
import { apiPost } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { pick } from "lodash";
import { toast } from "react-toastify";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const style = {
  marginBottom: "0",
  lineHeight: "1.42857143",
};

const Profile = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const [show, setShow] = useState(false);

  const onChangePassword = async (request) => {
    const { status, data: response_users } = await apiPost(
      apiPath.changePassword,
      pick(request, ["oldPassword", "newPassword"]),
    );
    if (status === 200 && response_users.success) {
      toast.success(response_users.message);
      setShow(false);
    } else {
      toast.error(response_users.message);
    }
  };

  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        <h2>Profile</h2>
        <div className="event-left">
          <div className="profile-wrap">
            <h3>About You</h3>
            <dl>
              <dd style={style}>Full Name</dd>
              <dd style={style}>{user?.username || "--"}</dd>

              <dd style={style}>Domain</dd>
              <dd style={style}>{user?.domain || "--"}</dd>

              <dd style={style}>Password</dd>
              <dd style={style} className="edit-pass">
                ********************************
                <a onClick={() => setShow(true)} className="favor-set">
                  Edit
                </a>
              </dd>
            </dl>
          </div>
        </div>

        <div className="event-right">
          <div className="profile-wrap">
            <h3>Limits &amp; Commission</h3>
            <dl>
              <dd style={style}>Exposure Limit</dd>
              <dd style={style} id="mainwalletExposureLimit">
                {user?.exposureLimit ?? "--"}
              </dd>

              <dd style={style}>Cricket Share(%)</dd>
              <dd style={style}>
                <span>{user?.cricketShare ?? 0}%</span>
              </dd>

              <dd style={style}>Cricket Fancy Share(%)</dd>
              <dd style={style}>
                <span>{user?.cricketFancyShare ?? 0}%</span>
              </dd>

              <dd style={style}>Soccer Share(%)</dd>
              <dd style={style}>
                <span>{user?.soccerShare ?? 0}%</span>
              </dd>

              <dd style={style}>Soccer Goal Share(%)</dd>
              <dd style={style}>
                <span>{user?.soccerGoalShare ?? 0}%</span>
              </dd>

              <dd style={style}>Tennis Share(%)</dd>
              <dd style={style}>
                <span>{user?.tennisShare ?? 0}%</span>
              </dd>

              <dd style={style}>Indian Casino Share(%)</dd>
              <dd style={style}>
                <span>{user?.indianCasinoShare ?? 0}%</span>
              </dd>

              <dd style={style}>exchange commission (%)</dd>
              <dd style={style}>
                <span>{user?.commission ?? 0}%</span>
              </dd>
            </dl>
          </div>

          <div className="profile-wrap" style={{ display: "none" }}>
            <h3>PT</h3>
            <dl>
              <dt>My PT Allowed</dt>
              <dd>0%</dd>
            </dl>
            <dl>
              <dt>My Fancy Bet PT</dt>
              <dd>0%</dd>
            </dl>
            <dl>
              <dt>Sportsbook PT</dt>
              <dd>0%</dd>
            </dl>
            <dl>
              <dt>Sportsbook Premium PT</dt>
              <dd>0%</dd>
            </dl>
            <dl>
              <dt>My Book Maker PT</dt>
              <dd>0%</dd>
            </dl>
            <dl>
              <dt>Casino PT Allowed</dt>
              <dd>LIVE: 0%, RNG: 0%, SLOT: 0%, VIRTUAL: 0%</dd>
            </dl>
          </div>
        </div>
      </div>

      <ChangePassword isOpen={show} onClose={() => setShow(false)} onSubmit={onChangePassword} />
    </MyAccountLayout>
  );
};

export default Profile;
